{
  "materials": [
    {
      "id": "steel",
      "label": "Steel",
      "density_lb_per_in3": 0.283,
      "density_g_per_cm3": 7.85,
      "default_transfer": "spray_pulse",
      "disallowed_transfers": []
    },
    {
      "id": "stainless",
      "label": "Stainless Steel",
      "density_lb_per_in3": 0.289,
      "density_g_per_cm3": 8.0,
      "default_transfer": "spray_pulse",
      "disallowed_transfers": []
    },
    {
      "id": "aluminum",
      "label": "Aluminum",
      "density_lb_per_in3": 0.0954,
      "density_g_per_cm3": 2.8,
      "default_transfer": "spray_pulse",
      "disallowed_transfers": ["most_fcaw"]
    }
  ],
  "transfers": [
    {
      "id": "spray_pulse",
      "label": "Spray/Pulse",
      "efficiency": 0.98,
      "group": "gmaw"
    },
    {
      "id": "short_circuit",
      "label": "Short Circuit",
      "efficiency": 0.90,
      "group": "gmaw"
    },
    {
      "id": "most_fcaw",
      "label": "Most FCAW",
      "efficiency": 0.85,
      "group": "stick_fcaw"
    },
    {
      "id": "smaw",
      "label": "SMAW",
      "efficiency": 0.65,
      "group": "stick_fcaw"
    }
  ],
  "joints": [
    {
      "id": "surfacing",
      "label": "Surfacing",
      "image": "Surfacing - Lined",
      "fields": [
        { "id": "B1", "label": "B1" },
        { "id": "W", "label": "W" }
      ]
    },
    {
      "id": "square_groove",
      "label": "Square Groove",
      "image": "Square Groove - Lined",
      "fields": [
        { "id": "T1", "label": "T1" },
        { "id": "R", "label": "R" },
        { "id": "B1", "label": "B1" }
      ]
    },
    {
      "id": "outside_corner",
      "label": "Outside Corner",
      "image": "Outside Corner - Lined",
      "fields": [
        { "id": "A1", "label": "A1", "type": "angle" },
        { "id": "FRE", "label": "FRE" },
        { "id": "R", "label": "R" },
        { "id": "T1", "label": "T1" }
      ]
    },
    {
      "id": "fillet",
      "label": "Fillet",
      "image_plus": "Fillet FRE Plus - Lined",
      "image_minus": "Fillet FRE Minus - Lined",
      "fields": [
        { "id": "FRE", "label": "FRE" },
        { "id": "L1", "label": "L1" },
        { "id": "L2", "label": "L2" }
      ],
      "options": { "fre_polarity_toggle": true }
    },
    {
      "id": "single_bevel",
      "label": "Single Bevel Groove",
      "image": "Single Bevel Groove - Lined",
      "fields": [
        { "id": "T1", "label": "T1" },
        { "id": "A1", "label": "A1", "type": "angle" },
        { "id": "R", "label": "R" },
        { "id": "L", "label": "L" },
        { "id": "B1", "label": "B1" }
      ]
    },
    {
      "id": "single_v",
      "label": "Single V Groove",
      "image": "Single V Groove - Lined",
      "fields": [
        { "id": "T1", "label": "T1" },
        { "id": "A1", "label": "A1", "type": "angle" },
        { "id": "R", "label": "R" },
        { "id": "L", "label": "L" },
        { "id": "B1", "label": "B1" }
      ]
    },
    {
      "id": "single_j",
      "label": "Single J Groove",
      "image": "Single J Groove - Lined",
      "fields": [
        { "id": "T1", "label": "T1" },
        { "id": "A1", "label": "A1", "type": "angle" },
        { "id": "R", "label": "R" },
        { "id": "L", "label": "L" },
        { "id": "B1", "label": "B1" },
        { "id": "RD", "label": "RD" }
      ]
    },
    {
      "id": "single_u",
      "label": "Single U Groove",
      "image": "Single U Groove - Lined",
      "fields": [
        { "id": "T1", "label": "T1" },
        { "id": "A1", "label": "A1", "type": "angle" },
        { "id": "R", "label": "R" },
        { "id": "L", "label": "L" },
        { "id": "B1", "label": "B1" },
        { "id": "RD", "label": "RD" }
      ]
    }
  ]
}
